import axios from "axios";

export function getBookmarkedArticles(externalUserId) {
  let payload = {
    externalUserId,
  };

  return axios.post("article/bookmarks", payload);
}

export function bookmarkArticle(articleId, externalUserId) {
  let payload = {
    articleId,
    externalUserId,
  };

  return axios.post("article/bookmark", payload);
}

export function removeBookmarkArticle(articleId, externalUserId) {
  let payload = {
    articleId,
    externalUserId,
  };

  return axios.post("article/bookmark/remove", payload);
}
